module.exports = __webpack_public_path__ + "assets/img/0_01id.9b7b2e49.jpg";